var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorimg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 77,
    viewBox: "0 0 350 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313.507 0.859619C294.804 0.859619 279.487 15.4393 277.351 34.1651C226.666 38.2773 77.933 38.5492 19.2614 34.6748C17.7823 30.9025 14.1995 28.2177 10.0251 28.2177C4.50309 28.2177 0 32.8397 0 38.5832C0 44.3267 4.50309 48.9486 10.0251 48.9486C14.1995 48.9486 17.7494 46.2978 19.2614 42.5594C85.986 38.6171 219.468 38.991 277.384 43.1372C279.553 61.829 294.87 76.3407 313.507 76.3407C333.656 76.3407 349.992 59.45 349.992 38.6171C349.992 17.7842 333.656 0.893612 313.507 0.893612V0.859619Z",
    fill: "#7FA8AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorimg3);
export default __webpack_public_path__ + "static/media/Vectorimg3.747634685fa9605c3078ebfc3eadc68d.svg";
export { ForwardRef as ReactComponent };